import Link from 'next/link'
import { memo } from 'react'

import { RelatedContentListItem } from './RelatedContentListItem'

interface Props {
  contents: any[]
  slug?: string
  totalRelatedContent?: number
}

export const RelatedContents: React.FC<Props> = memo(({ contents, slug, totalRelatedContent = 0 }) => {
  const firstFiveRecords = contents?.slice(0, 5)

  return (
    <>
      {firstFiveRecords && firstFiveRecords.length > 0 && (
        <div>
          <h2 className="mt-[2rem] Cart_cartHeaderTitle__9zl5e font-secondary mb-[22px]">Related Content</h2>
          <div className="w-[240px] px-[16px] py-[12px] border  rounded-[4px]">
            <ul className="mb-[8px] text-[#333333] relatedContentWrap">
              {firstFiveRecords.map((item) => (
                <RelatedContentListItem item={item} />
              ))}
            </ul>

            {totalRelatedContent > 0 && (
              <Link
                className="leading-[19px] text-[15px] block text-center font-primary text-[#011D58] font-bold"
                href={`/solution-contents/${slug}`}
                target={'_blank'}
              >
                View all
              </Link>
            )}
          </div>
        </div>
      )}
    </>
  )
})
